module.exports = __webpack_public_path__ + "static/mapping-the-world-cbfaf015c7488a5a393c88d61a177201.pdf";